import { useMemo } from "react";
import { BLOG_CATEGORY_ALL } from "../constants/blog";

/**
 * Filters a list of articles by category.
 *
 * @param {Array<import("../blog").ArticleShape>} articles - Article list to filter
 * @param {string} category - Active category name, or BLOG_CATEGORY_ALL for no filter
 * @returns {{ results: Array, isFiltered: boolean }}
 */
export function useBlogFilter(articles, category) {
  const isFiltered = category !== BLOG_CATEGORY_ALL;

  const results = useMemo(() => {
    if (!isFiltered) return articles;
    return articles.filter((a) => a.category === category);
  }, [articles, category, isFiltered]);

  return { results, isFiltered };
}
